<template>
  <div>
    <template v-if="$store.getters.getUserHasFeature('articles')">
      <articles-list
        v-if="loaded"
        :withFilters="true"
        :hasPagination="true"/>
    </template>
    <template v-else>
      <div class="wrapper pt-3 pb-1">
        <f-alert
          visible
          class="my-2"
          theme="inactive">
          <span>
          {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
          </span>
        </f-alert>
      </div>
    </template>

    <div
      v-if="!loaded"
      class="loading-spinner-wrapper">
      <div class="loading-spinner pb-3 pt-3">
        <span class="loading-spinner-content">
          {{ $t('ui.loadingDataInProgress') }}&hellip;
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import ArticlesList from '@/views/lists/ArticlesList.vue';

export default {
  name: 'articles',
  components: {
    'articles-list': ArticlesList
  },
  data() {
    return {
      userType: null,
      loaded: false,
      whereFilter: null
    };
  },
  mounted () {
    this.userType = this.$store.getters['getUserType'].toLowerCase();
    if (this.$route.query) {
      this.whereFilter = this.$route.query;
    }
    this.loaded = true;
  }
};
</script>
